export function mergeHolidaysWithSameDate(holidays) {
    const mapByDate = holidays.reduce((map, holiday) => {
        map[holiday.date] = !!map[holiday.date] ? {date: holiday.date, name: (map[holiday.date].name + " / " + holiday.name)} : holiday
        return map;
    }, {})
    return Object.values(mapByDate)
}


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/utils.js